import React, {useState, useContext} from 'react'
import { VenueContext } from "../Context"
import styled from "styled-components"
import {VenueImages} from "./VenueImages"
import { Gallery, GalleryImage } from "react-gesture-gallery";

function SingleVenue(props) {
    const [price, setPrice] = useState(Math.floor(Math.random() * 400))
    const [capacity, setcapacity] = useState(Math.ceil(Math.random() * 900))
    const [rating, setRating] = useState(Math.floor(Math.random() * 100))
    const [slug, setSlug] = useState(props.match.params.slug);
    const { getVenueDetails } = useContext(VenueContext);
    const [startTime, setStartTime] = useState("00:00");
    const [endTime, setEndTime] = useState("00:00");
    const [date, setDate] = useState("2018-08-26");


    let venueDetails = getVenueDetails(slug);
    if(!venueDetails){
        venueDetails = { name: "The Great Quarry", city: { name: "Los Angeles" }, openHoursDetail:"info pending"}
    }
    const [index, setIndex] = useState(0);

   function handleChange(event){
       event.preventDefault();
       const {value,name} = event.target;

    if (name === "stime"){
        setStartTime(value)
    }
    if (name === "etime") {
        setEndTime(value)
    }
    if (name === "date") {
        setDate(value)
    }
   }
   function handleButton(event){
       event.preventDefault();
   }
    return (
        <SingleVenueWrapper>
            <div className="container gallery-container">
                <div className="containing-gallery">
                    <Gallery
                        className="gallery mt-5 mx-auto"
                        style={{height:"50vh", width:"50vw", color:"white!important"}}
                        index={index}
                        onRequestChange={i => {
                            setIndex(i);
                        }}
                    >
                        {VenueImages.map(image =>
                            <GalleryImage className="gallery-image" src={image} alt="stages" />
                        )}

                    </Gallery>
                    <div className="row">
                        {VenueImages.map(image =>
                            <img src={image} alt="stages" className="col-3 img-row" />
                        )}
                    </div>
                </div>
            <div className="row mx-auto">
                <div className="col-8">
                        <p className="name-heading">{venueDetails.name}</p>
                        <span><i class="fas fa-map-marker-alt single-venue-location mr-2"></i><span className="city-tag">{venueDetails.city.name}</span> </span>
                        <i class="fas single-venue-users fa-users mx-2"></i>
                        <span className="capacity mr-2">{capacity}</span>
                        <i class="fas fa-star"></i><i class="fas fa-star"></i><i class="fas fa-star"></i><i class="fas fa-star"></i><i class="fas fa-star mr-2"></i>
                        <span className="rating">{rating}</span>
                        <p className="details-heading">Details</p>
                        <p className="details">Ideal for industry/networking events, product launches, marketing events, music 
                        release parties etc. Lighting, audio, staging, and AV equipment is also available onsite at 
                         discounted rates. Walls of the main space can be covered by black drapes available in house for acoustic or visual treatment. 
                        Additional rates may apply - please ask us.  Load in dock for vans and small trucks available. </p>
                </div>
                <div className="col-4">
                        <form action="submit" className="p-4 mt-3">
                         <p className="price mx-3"> <span className="price-tag ">${price}.00</span> <span className="price-label">Per Hour</span></p>
                        <label htmlFor="date">Date</label>
                            <input type="date" name="date" id="date" value={date} onChange={handleChange}/>
                        <span>
                                <label htmlFor="stime">Start Time</label>
                                <input type="time" name="stime" id="stime" value={startTime} onChange={handleChange} />
                                <label htmlFor="etime">End Time</label>
                                <input type="time" name="etime" id="etime" value={endTime} onChange={handleChange}/>

                        </span>
                        <button onClick={handleButton}>
                            Book Now
                        </button>
                    </form>
                </div>
            </div>
            </div>
        </SingleVenueWrapper>
    )
}
export const SingleVenueWrapper = styled.div`
font-family:"Circular,-apple-system,BlinkMacSystemFont,Roboto,Helvetica Neue,sans-serif "!important;

form{
    border-left: solid gray 1px;
}
label{
    font-size:1.2rem;
    margin-top: 1rem;
    color: black;
    font-weight: 800;
    text-transform: solid underline #B22222;
}
input{
    width: 300px;
    border: none;
    border-bottom: 1px solid grey;
    font-size: 1.1rem;

}
input:focus{
    text-decoration: none!important;
    border: none;
    highlight: none;
}
button{
    font-size: 1.2;
    color: white;
    border: 1px solid #B22222;
    background-color: #B22222;
    width: 300px;
    margin-top: 2rem;
    padding: .5rem;

}
.price-tag{
color: #B22222;
font-size: 1.8rem;
font-weight: 600;
}
.price-label{
font-size: 1.5rem;
font-weight: 600;
color: gray;
}
.details{
    font-size: 1rem;
    color:gray;
}
.details-heading{
color: black;
    font-size: 2rem;
    text-transform: capitalize;
    font-weight: 500;
    margin-bottom: .5rem;
    margin-top: .8rem;
}
.single-venue-users, .fa-star{
color: #B22222;
font-size: 1.1rem;
}
.capacity, .rating{
font-size: 1.5rem;
font-weight: 600;
color: gray;
}
.single-venue-location{
color: #B22222;
font-size: 1.8rem;
}
.city-tag{
    font-size: 2rem;
    font-weight: 400;
    right-margin: 0.3rem;
}
.name-heading{
    color: black;
    font-size: 2.5rem;
    text-transform: capitalize;
    font-weight: 600;
    margin-bottom: 2.5rem;
}
.name-head{
    color: black;
    font-size: 3.5rem;
    text-transform: capitalize;
    font-weight: 600;
    margin-bottom: 2.5rem;
    text-decoration: solid underline #B22222;
}
.gallery{
    object-fit: cover;
    overflow: hidden;
}

button{
    background-color: #B22222!important;
        font-family: var(--font);
        color:white;
        padding:0.5rem;
        font-weight:600;
     border: #B22222 solid 0.01rem;

}
.img-row{
    padding:1rem;
    background-color: white;
}
.bottom{
    background-color: white!important;
    padding-top: 5rem;
}

`
export default SingleVenue
